module.exports = __webpack_public_path__ + "static/media/Pixel2.png?v=572a6f04";